<template>
  <div style="position: relative;">
    <div class="custom-notification create">
      <div class="custom-notification__content" :class="{
      'has-overflow': overflow,
      'is-full-width': !sidebar
    }">
        <slot name="content"></slot>
      </div>
      <div v-if="sidebar" class="custom-notification__sidebar">
        <slot name="sidebar"></slot>
      </div>
    </div>
    <div class="custom-notification__cta" :class="{
      'has-overflow': overflow,
    }">
      <slot name="cta">
        <button v-if="lastPage" class="btn btn-default" type="button" @submit.prevent v-on:click="lastPage">
          <i class="fa fa-chevron-left"></i> Previous
        </button>
        <button class="btn btn-primary" type="button" @submit.prevent v-on:click="nextPage">
          Continue <i class="fa fa-chevron-right"></i>
        </button>
      </slot>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    overflow: {
      type: Boolean,
      default: true
    },
    sidebar: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    ...mapActions('notification', ['nextPage', 'lastPage'])
  }
}
</script>

<style lang="scss">
  @import 'src/assets/sass/bootstrap/variables';
  .custom-notification {
    display: flex;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    max-height: 85vh;
    justify-content: center;
    flex-flow: row wrap;
    padding: 30px 0;
    /*margin: 50px 0;*/
    margin-bottom: 50px;
    position: relative;
    &__content {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;
      padding-top: 30px;
      padding-bottom: 30px;
      margin-bottom: 75px;
      @media (min-width: 992px) {
        width: 75%;
      }
      &.is-full-width {
        width: 100%;
      }
      &.has-overflow {
        @media (min-width: 992px) {
          padding-bottom: 90px;
        }
      }
    }

    &__sidebar {
      width: 100%;
      padding: 30px;
      margin-bottom: 75px;
      @media (min-width: 992px) {
        width: 25%;
      }
      ul {
        padding-left: 0;
        list-style: none;
        width: 100%;
      }
      li {
        width: 100%;
        button {
          width: 100%;
          display: inline-flex;
          appearance: none;
          border: none;
          box-shadow: none;
          position: relative;
          padding: 5px 30px 5px 5px;
          text-transform: uppercase;
          font-size: 12px;
          &:focus,
          &:active {
            outline: none;
          }
          &:hover,
          &:active {
            background: $gray-lighter;
          }
          i {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 5px;
          }
        }
      }
      > button {
        width: 100%;
      }
    }
    &__content,
    &__sidebar {
      background: #fff;
      &.has-overflow {
        max-height: 75vh;
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }
    &__cta {
      width: 100%;
      padding: 30px;
      background-color: #fff;
      border-top: 1px solid $gray-lighter;
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 10;
      &.has-overflow {
        @media (min-width: 992px) {
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }

      > button {
        width: calc(100% - 15px);
      }
    }
    &__heading {
      padding: 0 15px;
      margin-bottom: 30px;
    }
    &__container {
      background-color: #fff;
      width: 100%;
      padding: 0 30px 30px;
    }

    &__form {
      margin-top: 30px;
      background-color: #fff;
      padding: 0 30px;
      @media (min-width: 992px) {
        padding: 0 calc(15% + 30px) 30px;
      }
    }

    &__selection {
      display: flex;
      flex-wrap: wrap;
      @media (min-width: 992px) {
        flex-wrap: nowrap;
      }
    }
    &__option {
      position: relative;
      width: 100%;
      padding: 10px;
      z-index: 0;

      input {
        position: absolute;
        z-index: 1;
        top: 50%;
        transform: translateY(-50%);
        width: 90px;
        appearance: none;
        height: 60px;
        margin: 0;
        &:focus,
        &:active {
          outline: none;
        }
        &::before,
        &::after {
          content: '';
          position: absolute;
          z-index: 1;
          background: none;
          top: 50%;
          left: 50%;
        }
        &::before {
          display: block;
          width: 2rem;
          height: 2rem;
          border: 2px solid var(--brand-text);
          transform: translate(-50%, -50%);
          transition: border-color 0.05s ease-in-out, background 0.05s ease-in-out;
        }
        &::after {
          content: '';
          border-bottom: 3px solid var(--brand-primary);
          border-right: 3px solid var(--brand-primary);
          display: block;
          width: .6rem;
          height: 1rem;
          position: absolute;
          z-index: 2;
          top: 50%;
          left: 50%;
          transform: scale(0) translate(-50%, calc(-50% - 0.125rem))
          rotate(45deg);
          transform-origin: center;
          transition: transform 0.3s ease-in-out;
          will-change: transform;
        }
        &:checked {
          &::before {
            border-color: var(--brand-primary);
          }
          &::after {
            transform: scale(1) translate(-50%, calc(-50% - 0.125rem))
            rotate(45deg);
          }
        }
      }
      label {
        cursor: pointer;
        width: 100%;
        padding: 30px 30px 30px 90px;
        margin-bottom: 0;
        background: $gray-lighter;
        font-family: $font-headings;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        height: 100%;
        display: flex;
        align-items: center;
        &:hover,
        &:active {
          background: darken($gray-lighter, 5%);
        }
      }
    }
  }
</style>
